import cn from 'classnames';
import AppLink from 'components/Common/Link/Link';
import React from 'react';

export interface OwnProps {
  children: React.ReactNode;
  isReact: boolean;
  link: string;
  className?: string;
  onClick?: any;
}

const ProductPageLink = ({ children, isReact, link, className, onClick }: OwnProps) => (
  <AppLink external={!isReact} to={link} className={cn(className, 'gtm-category-product')} onClick={onClick}>
    {children}
  </AppLink>
);

export default ProductPageLink;
